import { Business } from '@40seas/entities/businesses';
import { QueryDtoOf } from '@40seas/entities/common';

export class BuyerQueryDto extends QueryDtoOf(Business) {}
